export const NoMatch = () => {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 align-middle sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-indigo-600">404</p>
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Strona nie została znaleziona
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          Przepraszamy, nie znaleźliśmy strony której szukasz.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <a
            href="/"
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Strona główna
          </a>
          <a
            href="mailto:kontakt@skaner.ai"
            className="text-sm font-semibold text-gray-900"
          >
            Wsparcie techniczne <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </main>
  );
};
